import { useState } from 'react';
import { useEscape } from "../hooks/useEscape.js";
import type { NewTemplateInfo } from '../types/index.js';

interface Props {
  onConfirm: (info: NewTemplateInfo) => void;
  onCancel: () => void;
}

export function NewTemplateDialog({ onConfirm, onCancel }: Props) {
  useEscape(onCancel);
  const [label, setLabel] = useState('');
  const [width, setWidth] = useState('57');
  const [height, setHeight] = useState('32');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});

  function validate(): boolean {
    const errs: Record<string, string> = {};
    if (!label.trim()) errs['label'] = 'Label is required';
    const w = parseFloat(width);
    const h = parseFloat(height);
    if (isNaN(w) || w <= 0) errs['width'] = 'Width must be a positive number';
    if (isNaN(h) || h <= 0) errs['height'] = 'Height must be a positive number';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  }

  function handleSubmit() {
    if (!validate()) return;
    onConfirm({
      label: label.trim(),
      labelWidthMm: parseFloat(width),
      labelHeightMm: parseFloat(height),
      description: description.trim() || undefined,
    });
  }

  return (
    <div className="dialog-overlay">
      <div className="dialog">
        <h3>New Template</h3>
        <div className="form-group">
          <label>Label name *</label>
          <input
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            placeholder="e.g. Microgreen Sachet Standard"
            autoFocus
          />
          {errors['label'] && <span className="form-error">{errors['label']}</span>}
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Width (mm) *</label>
            <input
              type="number"
              value={width}
              onChange={(e) => setWidth(e.target.value)}
              min="1"
              max="1000"
              step="0.1"
            />
            {errors['width'] && <span className="form-error">{errors['width']}</span>}
          </div>
          <div className="form-group">
            <label>Height (mm) *</label>
            <input
              type="number"
              value={height}
              onChange={(e) => setHeight(e.target.value)}
              min="1"
              max="1000"
              step="0.1"
            />
            {errors['height'] && <span className="form-error">{errors['height']}</span>}
          </div>
        </div>
        <div className="form-group">
          <label>Description</label>
          <input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Optional description"
          />
        </div>
        <div className="dialog__actions">
          <button className="btn" onClick={onCancel}>Cancel</button>
          <button className="btn btn--primary" onClick={handleSubmit}>
            Open Designer
          </button>
        </div>
      </div>
    </div>
  );
}
